import { defaultRanges } from '../utils/datetime';
import { Button, Box } from '@material-ui/core';

const DateRangeOptionButtonGroup = ({ onChange, tz, timeMode }) => {
  const dropdownRange = defaultRanges(tz, timeMode);
  return (
    <>
      {dropdownRange.map((value, key) => (
        <Box key={key} pr={1}>
          <Button
            variant="contained"
            color="primary"
            key={key}
            onClick={() => onChange?.({ ...value })}
          >
            {value.label}
          </Button>
        </Box>
      ))}
    </>
  );
};

export default DateRangeOptionButtonGroup;
